import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"

import player from "@frog/source/data/player.js"
import chapters from "@frog/source/data/encounters/chapters.js"
// import tests from "@frog/source/tests/_.js" // TODO: lazy load this and all other imports to this file
import Director from "@frog/source/juice/Director.js"

import * as Objdict from "objdict"

const DEFAULT_APP = {
    "game": {
        "player": player,
        "encounter": {},
    }
}

if(typeof window != "undefined") {
    window.setTimeout(() => {
        Navigation.load(window.location.hash)
    })
    window.addEventListener("hashchange", (event) => {
        // console.log("THE HASH HAS BEEN EDITED")
        Navigation.load(window.location.hash)
    })
}

class UserError extends Error {}

const Navigation = new class {
    constructor() {
        this.routes = []
        this.state = {"screen": "SplashScreen"}
    }
    go(path = "", data = {}) {
        data.path = data.path || path
        window.location.hash = JSON.stringify(data)

        // window.location.hash = path

        // window.history.replaceState(data, "Frog " + Math.floor(Math.random() * 1000), "#" + path)

        // this.load(path, data)
    }
    load(path) { //, data) {
        path = decodeURIComponent(path)
        path = path[0] == "#" ? path.substring(1) : path

        let data
        try {
            data = JSON.parse(path)
        } catch {
            // console.log("could not parse hash as json", path)
            return
        }
        if(data.path != undefined) {
            path = data.path
        }
        this.path = path

        if(path.charAt(path.length - 1) == "/") {
            path = path.substring(0, path.length - 1)
        }
        // console.log("Routing", path)
        this.request = {
            "path": path,
            "data": data
        }
        for(let index in this.routes) {
            const route = this.routes[index]
            // console.log(request.path, "->", route.path)
            const match = this.request.path.match(route.path)
            if(match != undefined) {
                this.request.wildcards = match.groups
                try {
                    this.response = route.func(this.request)
                    if(this.response != undefined) {
                        return this.state = this.response
                    }
                } catch(error) {
                    this.request.error = error

                    if(error instanceof UserError) {
                        this.state = this.onUserError(this.request)
                    } else { // if(error instanceof Error) {
                        this.state = this.onError(this.request)
                    }

                    throw error
                }
            }
        }
    }
    on(path, func) {
        if(path instanceof Error) {
            this.routes[path] = {path, func}
            return
        }
        if(path instanceof RegExp != true) {
            path = path.replace(/\*/g, "(.*)")

            const WILDCARDS = /\:[a-zA-Z]+/g
            const wildcards = path.match(WILDCARDS)
            if(wildcards != undefined) {
                wildcards.forEach((wildcard) => {
                    path = path.replace(wildcard, "(?<" + wildcard.substring(1) + ">.*)")
                })
            }

            path = new RegExp("^" + path + "$", "i")
        }
        this.routes.push({path, func})
    }
}

export default Navigation

Navigation.on("/", function(request) {
    Audiomix.trigger("Music:Title")
    Audiomix.trigger("Ambience:General")

    return {"screen": "SplashScreen"}
    // TODO: if first time, play animations for splashing
})

Navigation.on("/credits", function(request) {
    Audiomix.trigger("Music:Title")
    Audiomix.trigger("Ambience:General")

    return {"screen": "CreditsScreen", "time": window.performance.now()}
})

Navigation.on("/game", function(request) {
    Audiomix.trigger("Music:Title")
    Audiomix.trigger("Ambience:General")

    return {"screen": "TitleScreen", "time": window.performance.now()}
    // if(App.game == undefined) {
    //     // console.log("Creating game")
    //     App.load({
    //         "game": {
    //             "player": player,
    //             "encounter": {}
    //         },
    //     })
    //     // TODO: Run any on-new-game scripting, music, etc.
    //     // TODO: Move this into an express-style middleware!!
    // }
    // return {"screen": "OverworldScreen"}
})

Navigation.on("/game/chapters", function(request) {
    Audiomix.trigger("Music:Title")
    Audiomix.trigger("Ambience:General")

    return {"screen": "ChapterSelectScreen"}
})

Navigation.on("/game/town", function(request) {
    if(request.data != undefined
    && request.data.score != undefined) {
        player.score = request.data.score // it overrides, does not add
        // TODO: Should we be worried about calling this method multiple times and mutating the player data multiple times? where is this data coming from?
    }
    Audiomix.trigger("Music:Town")
    Audiomix.trigger("Ambience:Town")

    App.load({
        "game": {
            "player": player,
        }
    })
    return {"screen": "TownScreen"}
})

// Navigation.on("/game/units", function(request) {
//     if(App.game == undefined) {
//         App.load(DEFAULT_APP)
//     }
//
//     return {"screen": "UnitsScreen"}
// })
//
// Navigation.on("/game/units/:unitKey/levels", function(request) {
//     if(App.game == undefined) {
//         App.load(DEFAULT_APP)
//     }
//
//     if(App.game.player.party.units[request.wildcards.unitKey] == undefined) {
//         throw new UserError("Could not find player " + request.wildcards.unitKey)
//     }
//
//     return {
//         "screen": "UnitLevelsScreen",
//         "unitKey": request.wildcards.unitKey,
//     }
// })
//
// Navigation.on("/game/units/:unitKey/skills", function(request) {
//     if(App.game == undefined) {
//         App.load(DEFAULT_APP)
//     }
//
//     if(App.game.player.party.units[request.wildcards.unitKey] == undefined) {
//         throw new UserError("Could not find player " + request.wildcards.unitKey)
//     }
//
//     return {
//         "screen": "UnitSkillsScreen",
//         "unitKey": request.wildcards.unitKey,
//     }
// })
//
// Navigation.on("/game/units/:unitKey", function(request) {
//     if(App.game == undefined) {
//         App.load(DEFAULT_APP)
//     }
//
//     if(App.game.player.party.units[request.wildcards.unitKey] == undefined) {
//         throw new UserError("Could not find player " + request.wildcards.unitKey)
//     }
//
//     return {
//         "screen": "UnitStatusScreen",
//         "unitKey": request.wildcards.unitKey
//     }
// })

Navigation.on("/game/encounters/*", function(request) {
    Audiomix.trigger({"key": "Music:Combat:A", "intensity": 0})
    Audiomix.trigger("Ambience:General")

    const slug = request.path.split("/").pop() // TODO: support RegExp wildcards??

    // if(App.game == undefined) {
    //     // console.log("Creating game")
    //     App.load({
    //         "game": {
    //             "encounter": {}
    //         },
    //     })
    //     // TODO: Move this into an express-style middleware!!
    // }
    if(chapters[slug] == undefined) {
        throw new UserError("Could not find encounter " + slug)
    }

    // TODO: Load this dev state from your friendly json payload.
    // const app = require("@frog/source/data/devstate.js")

    //if(App.game.encounter == undefined || App.game.encounter.slug != slug) {
    // console.log("Creating encounter", slug)

    App.load({
        "game": {
            "player": player,
            "encounter": chapters[slug],
            "chapterParty": request.data && request.data.chapterParty,
            // TODO: let references be
        }
    })

    return {"screen": "EncounterScreen"}
})

Navigation.on("/dev/tests", function(request) {
    return {"screen": "SplashScreen", "devscreen": "TestListScreen"}
})

Navigation.on("/dev/tests/*", function(request) {
    const slug = request.path.substring(11) // TODO: support RegExp wildcards??
    // import("@frog/source/tests/_.js").then((tests) => {tests = tests.default
    // console.log("Loading test", slug)
    const test = tests.find((test) => test.slug == slug)
    if(test == undefined) {
        throw new UserError("Could not find test " + slug)
    }
    if(test.snapshot == undefined) {
        throw new UserError("Could not find snapshot for test " + slug)
    }
    App.loadTest(test)
    return {"screen": "EncounterScreen", "devscreen": "TestListScreen", "testslug": slug}
})

Navigation.on("/*", function(request) {
    throw new UserError("Could not find " + request.path)
})

Navigation.onUserError = function(request) {
    return {"screen": "ErrorScreen", "message": request.error.message}
}
Navigation.onError = function(request) {
    return {"screen": "ErrorScreen", "message": "Something went wrong!!"}
}

window.frog = window.frog || {}
window.frog.navigation = Navigation

// SPLASH SCREEN

// // TODO: centralize this along with the view navigation
// // const isExplicitlyTesting = params.get("test") != null
// // if(isExplicitlyTesting == true) {
// //     window.frog.test.log()
// // }
// window.frog.test.log()
// window.frog.navigation = {"screen": "TestListScreen"}
